import React from "react";
import { Box, Typography, Stack, CircularProgress, Alert, Snackbar } from "@mui/material";
import TriviaCollectibleTeaser from "./TriviaCollectibleTeaser";
import TriviaDailyHero from "./TriviaDailyHero";
import TriviaModeCard from "./TriviaModeCard";
import TriviaProgressRail from "./TriviaProgressRail";
import TriviaCommunityPanel from "./TriviaCommunityPanel";
import { ARCADE_ACCENT } from "../../utils/triviaArcade";

const TriviaHub = ({
  userStats,
  daily,
  globalLeaderboard,
  streakLeaderboard,
  speedLeaderboard,
  dailyLeaderboard,
  achievements,
  achievementCatalog,
  gameHistory,
  historyPagination,
  onHistoryPageChange,
  isLoading,
  isLoadingLeaderboards,
  communityTab,
  onCommunityTabChange,
  onQuickPlay,
  onCustom,
  onDailyPlay,
  onViewDailyBoard,
  reducedMotion,
  error,
  onDismissError,
}) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          py: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <CircularProgress sx={{ color: ARCADE_ACCENT, mb: 2 }} />
        <Typography variant="h6">Loading your trivia stats…</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Almost ready to play.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ pb: 4 }}>
      <Typography variant="h3" fontWeight={800} sx={{ mb: 1 }}>
        Trivia Arcade
      </Typography>
      <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
        One tap in. Photo cards. Daily bragging rights.
      </Typography>

      <TriviaCollectibleTeaser onPlayDaily={onDailyPlay} />

      <TriviaProgressRail userStats={userStats} />

      <TriviaDailyHero
        date={daily?.date}
        played={daily?.played}
        userScore={daily?.userScore}
        participantCount={daily?.participantCount}
        onPlay={onDailyPlay}
        onViewLeaderboard={onViewDailyBoard}
        reducedMotion={reducedMotion}
      />

      <Stack direction={{ xs: "column", md: "row" }} spacing={2} sx={{ mb: 4 }}>
        <TriviaModeCard
          title="Quick Play"
          subtitle="5 questions · Medium · Career stats · 30s"
          cta="Play now"
          onClick={onQuickPlay}
        />
        <TriviaModeCard
          title="Custom"
          subtitle="Pick category, difficulty, count, and timer"
          cta="Configure"
          onClick={onCustom}
        />
      </Stack>

      <TriviaCommunityPanel
        initialTab={communityTab}
        globalLeaderboard={globalLeaderboard}
        streakLeaderboard={streakLeaderboard}
        speedLeaderboard={speedLeaderboard}
        dailyLeaderboard={dailyLeaderboard}
        achievements={achievements}
        achievementCatalog={achievementCatalog}
        gameHistory={gameHistory}
        historyPagination={historyPagination}
        onHistoryPageChange={onHistoryPageChange}
        isLoadingLeaderboards={isLoadingLeaderboards}
        isLoadingStats={isLoading}
        onTabChange={onCommunityTabChange}
      />

      <Snackbar open={Boolean(error)} autoHideDuration={4000} onClose={onDismissError}>
        <Alert severity="error" onClose={onDismissError}>
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TriviaHub;
